import React from "react"
import { message } from 'antd'
import { Route, Switch } from 'react-router-dom'
import createHashHistory from 'history/createHashHistory'
import Footer from '../../components/common/NHFooter/index'
import HeaderSearch from './headerSearch'
import AutoHandleSearch from './autoHandle/autoHandleSearch'
import AutoHandleForm from './autoHandle/autoHandleForm'
import Process from './process'
import StepForm from './steps/index'
import {  NHConfirm } from '../common/NHModal';

import styles from './index.css'
import NHFetch from "../../utils/NHFetch";
import {getLoginUser} from "../../utils/NHCore";

const hashHistory = createHashHistory();
const basicUrl = '/yxxc/'; //基础请求路径

export default class Welcome extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lcid: '', //当前流程ID
            dqlcpz: {}, //当前流程配置信息
            lcpzData: [], //所有流程配置信息
            studentData: {}, //学生信息
            pieData: {}, //流程统计数据
            stepsData: [], //流程步骤配置信息
            hjblztData: {},//环节办理状态信息
            hjywxData: [],//环节业务项信息
            ybllchjData: [],//学生已办理的流程环节
            searchParams: {},
            showAutoHandlePage: false,    //是否展示自动办理页面
            autoHJblztData:{},     //自动办理环节状态数据
            autoLchjData:{},      //自动办理环节信息
            autoStudentData:{},   //自动办理学生信息
            autoLoading:false
        }
    }

    componentDidMount() {
        if (!this.state.lcpzData || this.state.lcpzData.length == 0) {
            hashHistory.push('/yxxc');
        }
    }

    //当流程加载完毕时回调
    handleProcessLoad = (lcid, dqlcpz, lcpzData) => {
        //保存当前流程ID、配置信息
        this.setState({
            lcid: lcid,
            dqlcpz: dqlcpz,
            lcpzData: lcpzData,
            studentData: {},
            pieData: {},
            stepsData: [],
            hjblztData: {},
            hjywxData: [],
            ybllchjData: [],
        });
    }

    //搜索
    handleSearch = (searchParams, onFinish) => {

        //查询学生信息
        let p1 = this.getStudentData(searchParams);

        Promise.all([p1]).then((res) => {
            onFinish();
        }).catch((err) => {
            onFinish();
        });
    }

    //查询学生信息
    getStudentData = (searchParams, flag) => {
        this.setState({ searchParams: searchParams });
        return NHFetch(basicUrl + 'getStudentInfoByFilter', 'GET', searchParams)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        let dqlcpz = this.state.lcpzData.filter(item => item.lcdyVO.pkid == data.lcid)[0];
                        this.setState({ studentData: data, lcid: data.lcid, dqlcpz: dqlcpz }, () => {
                            //根据流程ID获取流程总体报到统计数据
                            this.loadPieStatisticalData(data.lcid);
                            //获取流程环节办理统计数据
                            this.loadStepsStatisticalData(data.lcid);
                            //获取学生已办理的流程环节
                            this.getAllLinkOfFinish(data.xsid);
                            //跳转页面
                            this.linkToStep(data, flag);
                        });

                    } else {
                        message.error('未查询到学生信息，可能原因：1.学生帐号不存在；2.当前登录用户无办理该学生的权限；3.学生未加入到迎新流程');
                        this.setState({ studentData: {}, hjblztData: {}, hjywxData: {} });
                    }
                }
            });
    }

    //根据流程ID获取流程总体报到统计数据
    loadPieStatisticalData = (lcid = '') => {

        return NHFetch(basicUrl + 'getPieStatisticalData', 'GET', { lcid: lcid })
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        let pieData = { bdrs: data.bdrs ? data.bdrs : 0, zrs: data.zrs ? data.zrs : 0 };
                        this.setState({ pieData: pieData });
                    } else {
                        this.setState({ pieData: { bdrs: 0, zrs: 0 } });
                    }
                }
            });
    }

    //获取流程环节办理统计数据
    loadStepsStatisticalData = (lcid = '') => {
        return NHFetch(basicUrl + 'getTableStatisticalData', 'GET', { lcid: lcid })
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ stepsData: data });
                    } else {
                        this.setState({ stepsData: [] });
                    }
                }
            });
    }

    //获取环节办理状态信息
    getHjblztData = (params) => {

        NHFetch(basicUrl + 'getHjblztByFilter', 'GET', params)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        let blzt = data.blzt;
                        this.setState({ hjblztData: data });
                    } else {
                        this.setState({ hjblztData: {} });
                    }
                }
            });
    }

    //获取环节业务项信息
    getHjywxData = (params) => {

        NHFetch(basicUrl + 'getHjywxByFilter', 'GET', params)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ hjywxData: data });
                    } else {
                        this.setState({ hjywxData: [] });
                    }
                }
            });
    }

    //获取学生所有已办理的流程环节
    getAllLinkOfFinish = (xsid) => {
        NHFetch(basicUrl + 'getAllLinkOfFinishedByXsid', 'GET', { xsid })
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ ybllchjData: data });
                    } else {
                        this.setState({ ybllchjData: [] });
                    }
                }
            });
    }

    //查询学生信息后，默认跳转到当前用户有操作权限的第一个的步骤页面，如果是取消或办理环节（flag为submit或cancel），则留在当前步骤
    linkToStep = (studentData, flag) => {
        let { lchjVOs } = this.state.dqlcpz;
        if (lchjVOs) {

            // 如果是取消或办理环节（flag为submit或cancel），则留在当前步骤，只刷新学生环节办理状态与数据
            if (flag) {
                let urlParams = this.parseUrlParams();
                let hjywxFilterParams = {};//环节业务项过滤条件
                hjywxFilterParams.xsid = studentData.xsid;
                hjywxFilterParams.hjid = urlParams.hjid;
                hjywxFilterParams.lchjid = urlParams.lchjid;

                this.getHjblztData(hjywxFilterParams);
                this.getHjywxData(hjywxFilterParams);

            } else {
                let currentStep = 0;
                //获取当前有操作权限的、可操作的第一个环节
                let available = lchjVOs.filter(item => item.czqx == '1' && item.zt == '1')[0];
                if (available) {
                    //获取第一个可操作环节代码
                    let { pkid, hjid, hjdm } = available;
                    for (let key = 0; key < lchjVOs.length; key++) {
                        if (lchjVOs[key].hjdm == hjdm) {
                            //当前可操作环节在整个流程步骤中的位置
                            currentStep = key;
                            break;
                        }
                    }

                    let filter = encodeURIComponent(`key=${currentStep}&lcid=${this.state.lcid}&hjid=${hjid}&lchjid=${pkid}`);

                    //如果是自定义环节
                    if (hjdm.indexOf('ZDY') != -1) {

                        hashHistory.push({
                            pathname: '/yxxc/step',
                            search: filter
                        });
                    } else {
                        switch (hjdm) {
                            case 'GD001':
                                //绿色通道
                                hashHistory.push({
                                    pathname: '/yxxc/step/lstd',
                                    search: filter
                                });
                                break;
                            case 'GD002':
                                //缴费办理
                                hashHistory.push({
                                    pathname: '/yxxc/step/jfbl',
                                    search: filter
                                });
                                break;
                            case 'GD003':
                                //宿舍分配
                                hashHistory.push({
                                    pathname: '/yxxc/step/ssfp',
                                    search: filter
                                });
                                break;
                            case 'GD003_1':
                                    //宿舍分配（安徽工商）增加走读申请功能
                                hashHistory.push({
                                    pathname: '/yxxc/step/ssfpFa',
                                    search: filter
                                });
                                break;
                            case 'GD003_2':
                                    //宿舍分配（武汉软件）
                                hashHistory.push({
                                    pathname: '/yxxc/step/ssfpFb',
                                    search: filter
                                });
                                break;
                            case 'GD006':
                                //现场分班
                                hashHistory.push({
                                    pathname: '/yxxc/step/xcfb',
                                    search: filter
                                });
                                break;
                            case 'GD006_1':
                                //现场分班(恩施职业)
                                hashHistory.push({
                                    pathname: '/yxxc/step/eszyXcfb',
                                    search: filter
                                });
                                break;
                            case 'GD006_2':
                                //现场分班(安徽工商)
                                hashHistory.push({
                                    pathname: '/yxxc/step/ahgsXcfb',
                                    search: filter
                                });
                                break;    
                            case 'GD007_1':
                                 //	军训服装（展示尺码信息）
                                hashHistory.push({
                                    pathname: '/yxxc/step/jxfzcmxx', 
                                    search: filter
                                });
                                break;
                            case 'GD002_1':
                                //缴费办理
                                hashHistory.push({
                                    pathname: '/yxxc/step/jfblFxxy',
                                    search: filter
                                });
                                break;
                            case 'GD002_2':
                                //缴费办理
                                hashHistory.push({
                                    pathname: '/yxxc/step/jfblFb',
                                    search: filter
                                });
                                break;
                            case 'GD001_1':
                                //深圳技大--绿色通道
                                hashHistory.push({
                                    pathname: '/yxxc/step/szjdLstd',
                                    search: filter
                            });
                                break;
                            case 'GD001_3':
                                //昭通学院--绿色通道
                                hashHistory.push({
                                    pathname: '/yxxc/step/ztxyLstd',
                                    search: filter
                            });
                                break;
                            case 'GD001_2':
                                //江汉艺术--绿色通道
                                hashHistory.push({
                                    pathname: '/yxxc/step/jhyszyLstd',
                                    search: filter
                            });
                                break;
                            case 'GD001_4':
                                //云南体职院--绿色通道
                                hashHistory.push({
                                    pathname: '/yxxc/step/yntzyLstd',
                                    search: filter
                            });
                                break;
                            case 'GD001_5':
                                //安徽工商--绿色通道
                                hashHistory.push({
                                    pathname: '/yxxc/step/ahgsLstd',
                                    search: filter
                                });
                                break;
                            default:
                                message.error(`暂未配置代码为${hjdm}的环节页面，请联系管理员`);
                                break;
                        }
                    }

                    let hjywxFilterParams = {};//环节业务项过滤条件
                    hjywxFilterParams.xsid = studentData.xsid;
                    hjywxFilterParams.hjid = hjid;
                    hjywxFilterParams.lchjid = pkid;

                    this.getHjblztData(hjywxFilterParams);
                    this.getHjywxData(hjywxFilterParams);

                } else {
                    message.warning(`暂无可操作的环节，请检查是否已分配环节权限或环节是否启用`);
                }
            }

        }
    }

    //解析url搜索参数
    parseUrlParams() {
        let location = this.props.location;
        if (location) {
            const { search } = location;
            if (search) {
                let deocodeUrl = decodeURIComponent(search);
                let url = deocodeUrl.substring(1, search.length); //去除?
                let paramsStr = url.split('&'); //分割参数字符串

                if (paramsStr.length > 0) {

                    let params = {};
                    //解析成键值对形式对象
                    for (let key in paramsStr) {
                        let paramStr = paramsStr[key];
                        let paramObj = paramStr.split('=');
                        let obj = new Object;
                        obj[paramObj[0]] = paramObj[1];
                        Object.assign(params, obj);
                    }

                    return params;
                }
            }
        }
        return null;
    }

    // 获取路径中的当前步骤
    getCurrentStep() {
        let params = this.parseUrlParams();
        if (params) {
            return Number(params.key ? params.key : 0);
        }
    }

    // 环节办理完成回调
    handleFinish = (flag) => {
        let searchParams = this.state.searchParams;
        this.getStudentData(searchParams, flag);
        if (flag == 'submit' && this.headerSearch) {
            this.headerSearch.clear();
        }
    }

    changeAutoPageShow =() =>{
        this.setState({
            showAutoHandlePage:false,
            autoStudentData: {},
            autoHJblztData: {},
            autoLchjData: {}
        })
    }

    onAutoHandle =(lchjData) =>{
        NHConfirm("开启后，只办理当前环节的状态，如学生需要办理另一个环节或另一个流程，则需要老师手动切换，是否开启？", () => {
            this.setState({
                showAutoHandlePage:true,
                autoHJblztData:{blzt:'0'},
                autoLchjData:lchjData
            })
        }, "warn");
    }

    autoHandleSearch =(searchParams)=>{
        const { autoLchjData } = this.state;
        const { lcid,hjid } = autoLchjData;
        searchParams.lcid = lcid;
        searchParams.hjid = hjid;
        NHFetch(basicUrl + 'selectStudentData','POST',searchParams).then(res=>{
            if (res && res.data){
                this.setState({
                    autoStudentData:res.data['stuMap'],
                    autoHJblztData:res.data['hjztMap']?res.data['hjztMap'].BLZT == '1'? {blzt:'1'} : {blzt:'0'}:{blzt:'0'},
                    autoLoading:res.data['hjztMap'] ? res.data['hjztMap'].BLZT == '1'? false : true :true
                },()=>{
                    if (res.data['hjztMap'] && res.data['hjztMap'].BLZT == '1'){
                        message.info("该学生已办理了该环节")
                    }else {
                        this.autoHandleSubmit()
                    }
                })
            }else {
                message.error('未查询到学生信息，可能原因：1.学生帐号不存在；2.学生未加入到迎新流程');
                this.setState({ autoStudentData: {}, autoHJblztData: {}, autoLchjData: {} });
            }
        })
    }

    autoHandleSubmit=()=>{
        const { XSID } = this.state.autoStudentData;
        if (!XSID){
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }
        const { lcid,hjid } = this.state.autoLchjData;
        let params = { xsid: XSID, lcid: lcid, hjid: hjid };
        NHFetch(basicUrl + 'autoHandleSubmit','POST',params).then(res =>{
            if (res && res.code === 200){
                if (res.data == 1){
                    message.success("自动办理成功");
                    this.setState({
                        autoLoading:false,
                        autoHJblztData:{blzt:'1'}
                    })
                }
            }else {
                this.setState({
                    autoLoading:false 
                })
            }
        })
    }

    //取消办理
    autoHandleCancel = () => {
        const { lcid,hjid } = this.state.autoLchjData;
        const { XSID } = this.state.autoStudentData;
        let params = { xsid: XSID,lcid: lcid, hjid: hjid};
        NHConfirm("是否确定取消办理？", () => {
            this.setState({ autoLoading: true });
            NHFetch(basicUrl + 'autoHandleCancel', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理取消成功！');
                        } else {
                            message.error('环节办理取消失败，请重试！');
                        }
                    }
                    this.setState({ autoLoading: false, autoHJblztData:{blzt:'0'} });
                }).catch((ress) => {
                this.setState({ autoLoading: false });
            })
        }, "warn");

    }

    render() {

        const { lcid, dqlcpz, studentData, pieData, stepsData, hjblztData, hjywxData, ybllchjData,showAutoHandlePage } = this.state;
        return (
            <div>
            {
                !showAutoHandlePage ?
                    <div>
                        <div className={styles.page_header}>
                            <div className={styles.detail}>
                                <div className={styles.main}>
                                    <div className={styles.row}>
                                        <div className={styles.content}>
                                            <HeaderSearch wrappedComponentRef={(inst) => this.headerSearch = inst} onSearch={this.handleSearch} lcid={lcid} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Switch>
                                <Route
                                    exact path="/yxxc"
                                    render={({ location }) =>
                                        <Process location={location} onLoad={this.handleProcessLoad} />
                                    }
                                />
                                <Route
                                    path="/yxxc/step"
                                    render={({ location }) =>
                                        <StepForm
                                            location={location}
                                            lcid={lcid}
                                            studentData={studentData}
                                            lcpz={dqlcpz}
                                            pieData={pieData}
                                            stepsData={stepsData}
                                            hjblztData={hjblztData}
                                            hjywxData={hjywxData}
                                            ybllchjData={ybllchjData}
                                            onFinish={this.handleFinish}
                                            onAutoHandle={this.onAutoHandle}
                                        />
                                    }
                                />
                            </Switch>
                        </div>
                    </div>
                    :
                    <div>
                        <div className={styles.page_header}>
                            <div className={styles.detail}>
                                <div className={styles.main}>
                                    <div className={styles.row}>
                                        <div className={styles.content}>
                                            <AutoHandleSearch wrappedComponentRef={(inst) => this.headerSearch = inst} autoHandleSearch={this.autoHandleSearch}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <AutoHandleForm
                                location={location}
                                loading={this.state.autoLoading}
                                studentData={this.state.autoStudentData}
                                hjblztData={this.state.autoHJblztData}
                                lchjData={this.state.autoLchjData}
                                lcpz={dqlcpz}
                                autoHandleSubmit={this.autoHandleSubmit}
                                autoHandleCancel={this.autoHandleCancel}
                                changeAutoPageShow={this.changeAutoPageShow}
                            />
                        </div>
                    </div>
            }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/yxxc/index.js